import {useEffect} from 'react';
import {useSubdomainBrand} from '~/hooks/useSubdomainBrand';

/**
 * Using similar logic from Dynamic Favicon for the ZenDesk Script injection. They want new ZenDesk chatbots for each brand.
 */
export function ZenDesk({src}) {
  const windowReady = typeof window !== 'undefined';
  const brand = useSubdomainBrand();

  useEffect(() => {
    let script = document.getElementById('ze-snippet');
    if (src?.length && script?.src !== src) {
      if (!windowReady) return;
      if (src?.length > 1) {
        let zeWidgetLoadButtonContainer = document.getElementById(
          'ze-widget-load-button',
        );
        if (!zeWidgetLoadButtonContainer) {
          const lang = navigator.language.substring(0, 2);
          let translatedHelp;
          switch (lang) {
            case 'en':
              translatedHelp = 'Help';
              break;
            case 'es':
              translatedHelp = 'Ayuda';
              break;
            case 'fr':
              translatedHelp = 'Aide';
              break;
            case 'de':
              translatedHelp = 'Hilfe';
              break;
            case 'it':
              translatedHelp = 'Aiuto';
              break;
            case 'pt':
              translatedHelp = 'Ajuda';
              break;
            case 'zh':
              translatedHelp = '帮助';
              break;
            case 'ja':
              translatedHelp = '助けて';
              break;
            case 'ko':
              translatedHelp = '도움';
              break;
            case 'ru':
              translatedHelp = 'Помощь';
              break;
            case 'ar':
              translatedHelp = 'مساعدة';
              break;
            default:
              translatedHelp = 'Help';
          }
          zeWidgetLoadButtonContainer = document.createElement('div');
          zeWidgetLoadButtonContainer.id = 'ze-widget-load-button';

          let zeWidgetIcon;
          switch (brand.name) {
            case 'orca':
              zeWidgetIcon =
                '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="20px" viewBox="0 0 20 20" xml:space="preserve" aria-hidden="true"><g></g><g></g><g></g><g><g><g><path d="M11,12.3V13c0,0-1.8,0-2,0v-0.6c0-0.6,0.1-1.4,0.8-2.1c0.7-0.7,1.6-1.2,1.6-2.1c0-0.9-0.7-1.4-1.4-1.4 c-1.3,0-1.4,1.4-1.5,1.7H6.6C6.6,7.1,7.2,5,10,5c2.4,0,3.4,1.6,3.4,3C13.4,10.4,11,10.8,11,12.3z"></path><circle cx="10" cy="15" r="1"></circle></g><path d="M10,2c4.4,0,8,3.6,8,8s-3.6,8-8,8s-8-3.6-8-8S5.6,2,10,2 M10,0C4.5,0,0,4.5,0,10s4.5,10,10,10s10-4.5,10-10S15.5,0,10,0 L10,0z"></path></g></g></svg>';
              break;
            case 'klymit':
              zeWidgetIcon =
                '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 15 16" xml:space="preserve" aria-hidden="true"><path d="M1.3,16c-0.7,0-1.1-0.3-1.2-0.8c-0.3-0.8,0.5-1.3,0.8-1.5c0.6-0.4,0.9-0.7,1-1c0-0.2-0.1-0.4-0.3-0.7c0,0,0-0.1-0.1-0.1 C0.5,10.6,0,9,0,7.4C0,3.3,3.4,0,7.5,0C11.6,0,15,3.3,15,7.4s-3.4,7.4-7.5,7.4c-0.5,0-1-0.1-1.5-0.2C3.4,15.9,1.5,16,1.5,16 C1.4,16,1.4,16,1.3,16z M3.3,10.9c0.5,0.7,0.7,1.5,0.6,2.2c0,0.1-0.1,0.3-0.1,0.4c0.5-0.2,1-0.4,1.6-0.7c0.2-0.1,0.4-0.2,0.6-0.1 c0,0,0.1,0,0.1,0c0.4,0.1,0.9,0.2,1.4,0.2c3,0,5.5-2.4,5.5-5.4S10.5,2,7.5,2C4.5,2,2,4.4,2,7.4c0,1.2,0.4,2.4,1.2,3.3 C3.2,10.8,3.3,10.8,3.3,10.9z"></path></svg>';
              break;
            default:
              zeWidgetIcon =
                '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="20px" viewBox="0 0 20 20" xml:space="preserve" aria-hidden="true"><g></g><g></g><g></g><g><g><g><path d="M11,12.3V13c0,0-1.8,0-2,0v-0.6c0-0.6,0.1-1.4,0.8-2.1c0.7-0.7,1.6-1.2,1.6-2.1c0-0.9-0.7-1.4-1.4-1.4 c-1.3,0-1.4,1.4-1.5,1.7H6.6C6.6,7.1,7.2,5,10,5c2.4,0,3.4,1.6,3.4,3C13.4,10.4,11,10.8,11,12.3z"></path><circle cx="10" cy="15" r="1"></circle></g><path d="M10,2c4.4,0,8,3.6,8,8s-3.6,8-8,8s-8-3.6-8-8S5.6,2,10,2 M10,0C4.5,0,0,4.5,0,10s4.5,10,10,10s10-4.5,10-10S15.5,0,10,0 L10,0z"></path></g></g></svg>';
          }
          zeWidgetLoadButtonContainer.innerHTML =
            '<button aria-label="' +
            translatedHelp +
            '" class="zen-desk-button-wrapper"><span class="zen-desk-button-icon" type="Icon">' +
            zeWidgetIcon +
            '</span><span class="zen-desk-button-label">' +
            translatedHelp +
            '</span></button>';
          zeWidgetLoadButtonContainer.addEventListener('click', () => {
            if (!script) {
              script = document.createElement('script');
              script.id = 'ze-snippet';
              script.onload = () => {
                zeWidgetLoadButtonContainer.remove();
                zE('webWidget', 'open');
              };
              document.getElementsByTagName('head')[0].appendChild(script);
            }
            script.src = src;
          });

          const targetDiv = document.querySelector(
            'body > div > div[class^="root-"]',
          );

          if (targetDiv) {
            targetDiv.appendChild(zeWidgetLoadButtonContainer);
          }
        }
      }
    }
  }, [windowReady, src]);

  return null;
}
